import React, { Component, Fragment } from 'react';
import {
    Container, Row, Col, Input, Label, Form, FormGroup, Button, Table
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import ConfirmButton from '../Modal/ConfirmButton';
import * as utilities from '../../utilities';
import Marketing2ActionsModal from './Marketing2ActionsModal';
import CompanyContext from '../../auth/CompanyContext';
// import { Link } from 'react-router-dom';
// import ReactTable from 'react-table';

class Marketing2CampaignsDemographicsTable extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.blankCampaignCompany = {
            active: true,
            auth0: '',
            campaignCompanyID: 0,
            campaignID: 0,
            description: '',
            endDate: '',
            isComplete: false,
            name: '',
            order: 0,
            secID: '',
            startDate: new Date().toLocaleDateString('en-CA')
        }

        this.state = {
            marketingCampaigns: [],
            newMarketingCampaignCompany: { ...this.blankCampaignCompany },
            editMarketingCampaignCompany: { ...this.blankCampaignCompany },
            showComplete: false,
            users: []
        }

        this.openActionsModal = null;
        this.closeActionsModal = null;
    }

    componentDidMount = () => {
        this.getMarketingCampaigns();
        this.getUsers();
    }

    onEdit = (campaignCompany) => {
        this.setState({
            editMarketingCampaignCompany: { ...campaignCompany }
        })
    }

    onChange = (e, type) => {
        e.persist();
        this.props.setUnsavedChanges(true);
        this.setState((prevState) => {
            let thisType = (type === 'edit') ? prevState.editMarketingCampaignCompany : prevState.newMarketingCampaignCompany;
            switch (e.target.type) {
                case "checkbox":
                    thisType[e.target.name] = !thisType[e.target.name];
                    break;
                default:
                    thisType[e.target.name] = e.target.value;
            }
            return (type === 'edit') ? { editMarketingCampaignCompany: thisType } : { newMarketingCampaignCompany: thisType };
        });
    }

    handleAdd = () => {
        fetch('/api/marketing2CampaignsCompanies/', {
            method: 'POST',
            body: JSON.stringify({
                campaignID: this.state.newMarketingCampaignCompany.campaignID,
                secID: this.props.secID,
                order: 10,
                auth0: this.props.user,
                startDate: this.state.newMarketingCampaignCompany.startDate,
                endDate: this.state.newMarketingCampaignCompany.endDate,
                active: this.state.newMarketingCampaignCompany.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newMarketingCampaignCompany: { ...this.blankCampaignCompany },
                    }, () => {
                        this.props.setUnsavedChanges(false);
                        this.props.getMarketingCampaignsCompanies();
                    });
                }
            });
    }

    handleEdit = () => {
        fetch('/api/marketing2CampaignsCompanies/' + this.state.editMarketingCampaignCompany.campaignCompanyID, {
            method: 'PUT',
            body: JSON.stringify({
                order: 10,
                auth0: this.props.user,
                startDate: this.state.editMarketingCampaignCompany.startDate != null ? String(this.state.editMarketingCampaignCompany.startDate).substring(0, 10) : null,
                endDate: this.state.editMarketingCampaignCompany.endDate != null ? String(this.state.editMarketingCampaignCompany.endDate).substring(0, 10) : null,
                isComplete: this.state.editMarketingCampaignCompany.isComplete,
                active: this.state.editMarketingCampaignCompany.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editMarketingCampaignCompany: { ...this.blankCampaignCompany },
                    }, () => {
                        this.props.setUnsavedChanges(false);
                        this.props.getMarketingCampaignsCompanies();
                    });
                }
            });
    }

    onToggleConfigureMarketingCampaign = () => {

    }

    onDelete = () => {
        fetch('/api/marketing2CampaignsCompanies/' + this.state.editMarketingCampaignCompany.campaignCompanyID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editMarketingCampaignCompany: { ...this.blankCampaignCompany },
                    }, () => {
                        this.props.setUnsavedChanges(false);
                        this.props.getMarketingCampaignsCompanies();
                    });
                }
            });
    }

    onDeleteComponent = (componentCompanyID) => {
        fetch('/api/marketing2ComponentsCompanies/' + componentCompanyID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.setUnsavedChanges(false);
                    this.props.getMarketingCampaignsCompanies();
                }
            });
    }

    handleCancel = () => {
        this.props.setUnsavedChanges(false);
        this.setState({
            editMarketingCampaignCompany: { ...this.blankCampaignCompany }
        })
    }

    formatDate = (d) => {
        if (d == null) return "";
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    formatTime = (isoString) => {
        const date = new Date(isoString);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;

        return hours + ':' + minutesStr + ' ' + ampm;
    }

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];
        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {
                return String(content).toLowerCase().includes(filter.value.toLowerCase());
            }
        }
        return true;
    };

    getUsers = () => {
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    users: results.data
                });
            });
    }

    getMarketingCampaigns = (cb) => {
        fetch('/api/marketing2Campaigns/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    marketingCampaigns: results.data,
                }, () => {
                    if (cb != null) cb();
                });
            });
    }

    changeAssignee = (componentCompanyID, component, auth0) => {
        const componentIndex = this.state.editMarketingCampaignCompany.components.findIndex(item => item.componentCompanyID === component.componentCompanyID);
        if (componentIndex === -1) return;
        this.setState((prevState) => {
            const newObj = { ...prevState }
            newObj.editMarketingCampaignCompany.components[componentIndex].auth0 = auth0;
            return {
                editMarketingCampaignCompany: newObj.editMarketingCampaignCompany
            }
        }, () => {
            fetch('/api/marketing2ComponentsCompanies/assignee/' + componentCompanyID, {
                method: 'PUT',
                body: JSON.stringify({
                    auth0: auth0
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    this.props.setUnsavedChanges(false);
                    this.props.getMarketingCampaignsCompanies();
                });
        })
    }

    snooze = (componentCompanyID, snooze) => {
        fetch('/api/marketing2ComponentsCompanies/snooze/', {
            method: 'PUT',
            body: JSON.stringify({
                componentCompanyID: componentCompanyID,
                snooze: snooze,
                auth0: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.props.setUnsavedChanges(false);
                this.props.getMarketingCampaignsCompanies();
                this.closeActionsModal();
            });
    }

    markCompanyComponentComplete = (campaignCompanyID, componentCompanyID, componentID, campaignID, secID, action, auth0, linkedCampaignCompanyIDs) => {
        fetch('/api/marketing2ComponentsCompanies/', {
            method: 'PUT',
            body: JSON.stringify({
                campaignCompanyID: campaignCompanyID,
                componentCompanyID: componentCompanyID,
                componentID: componentID,
                campaignID: campaignID,
                secID: secID,
                action: action,
                auth0: auth0,
                linkedCampaignCompanyIDs: String(linkedCampaignCompanyIDs || '').split(',').map(item => parseInt(item, 10)).filter(id => Number.isInteger(id) && id > 0)
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (!results.success) throw new Error('Unable to complete step');
                return fetch('/api/marketing2CampaignsCompanies/' + campaignCompanyID + '/complete', {
                    method: 'PUT',
                    headers: {
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-Database': this.context.company
                    }
                });
            })
            .then(results => results.json())
            .then(results => {
                if (!results.success) throw new Error(results.error || 'Unable to update campaign completion');
                if (results.campaignComplete) {
                    utilities.addToast('Campaign complete', 5, 'success');
                    this.setState(prevState => prevState.editMarketingCampaignCompany.campaignCompanyID === campaignCompanyID ? {
                        editMarketingCampaignCompany: {
                            ...prevState.editMarketingCampaignCompany,
                            isComplete: true,
                            endDate: results.endDate
                        }
                    } : null);
                }
                this.props.setUnsavedChanges(false);
                this.props.getMarketingCampaignsCompanies();
                this.closeActionsModal();
            })
            .catch((error) => {
                utilities.addToast(error.message || 'Unable to complete', 5, 'danger');
                this.props.getMarketingCampaignsCompanies();
            })
            ;
    }

    getCurrentDateLocal = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = (`0${now.getMonth() + 1}`).slice(-2); // Months are zero-indexed, add 1 to get the correct month
        const day = (`0${now.getDate()}`).slice(-2); // Add leading zero to day if necessary
        return `${year}-${month}-${day}`;
    }

    formatDueDate = (val) => {
        const endDateEpoch = new Date(String(val).substring(0, 10)).getTime();
        const todayEpoch = new Date(this.getCurrentDateLocal()).getTime();
        return endDateEpoch <= todayEpoch ? 'text-danger font-weight-bold' : '';
    }

    getToDoRender = (obj, hideActions) => {
        if (obj.isComplete) return;
        const endDateEpoch = new Date(String(obj.endDate).substring(0, 10)).getTime();
        const todayEpoch = new Date(this.getCurrentDateLocal()).getTime();
        let isFlowValueMatching = false;
        let retHTML = <>
            {obj.componentIsFlow &&
                <>
                    <Button
                        size={hideActions ? "md" : "sm"}
                        className='mt-0 mr-2'
                        disabled={this.state.editMarketingCampaignCompany.isComplete}
                        onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, { isFlowValueMatching: isFlowValueMatching }, obj.auth0, obj.linkedCampaignCompanyIDs)}
                        color="primary">
                        Confirm {isFlowValueMatching ? 'Match' : 'Not Matched'}
                    </Button>
                </>}
            {obj.componentIsSkip &&
                <>
                    <Button
                        size={hideActions ? "md" : "sm"}
                        className='mt-0 mr-2'
                        disabled={this.state.editMarketingCampaignCompany.isComplete}
                        onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, { skipResponse: true }, obj.auth0, obj.linkedCampaignCompanyIDs)}
                        color="primary">
                        Yes
                    </Button>
                    <Button
                        size={hideActions ? "md" : "sm"}
                        className='mt-0 mr-2'
                        disabled={this.state.editMarketingCampaignCompany.isComplete}
                        onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, { skipResponse: false }, obj.auth0, obj.linkedCampaignCompanyIDs)}
                        color="primary">
                        No
                    </Button>
                </>}
            {(hideActions == null || !hideActions) && <Button
                size={hideActions ? "md" : "sm"}
                className='mt-0 mr-2'
                color="primary"
                disabled={this.state.editMarketingCampaignCompany.isComplete}
                onClick={() => this.openActionsModal(obj, this.getToDoRender(obj, true), this.props.contacts)}
            >
                Actions
            </Button>}
            {!obj.componentIsSkip && !obj.componentIsFlow && (todayEpoch >= endDateEpoch) && <Button
                size={hideActions ? "md" : "sm"}
                className='mt-0 mr-2'
                disabled={this.state.editMarketingCampaignCompany.isComplete}
                onClick={() => this.markCompanyComponentComplete(obj.campaignCompanyID, obj.componentCompanyID, obj.componentID, obj.campaignID, obj.secID, obj.componentIsActivity ? obj.content : null, obj.auth0, obj.linkedCampaignCompanyIDs)}
                color="success">
                Done
            </Button>}
            {obj.componentSnooze > 0 && !obj.isSnooze && !obj.componentIsDelay && <Button
                size={hideActions ? "md" : "sm"}
                className='mt-0 mr-2'
                disabled={this.state.editMarketingCampaignCompany.isComplete}
                onClick={() => this.snooze(obj.componentCompanyID, obj.componentSnooze)}
                color="warning">
                Snooze {obj.componentSnooze}d
                {/* Snooze ({obj.componentSnooze})d Day{obj.componentSnooze === 1 ? '' : 's'} */}
            </Button>}
            {/* {obj.} */}
        </>;
        return retHTML;
    }

    standardRow = (marketingCampaignCompany) => {
        return (
            <tr className="adminRow pointer text-left" onClick={() => this.onEdit(marketingCampaignCompany)}>
                <td>{marketingCampaignCompany.name}
                    {marketingCampaignCompany.description && <div><label>{marketingCampaignCompany.description}</label></div>}
                </td>
                <td>{marketingCampaignCompany.typeLabel}</td>
                <td>{this.formatDate(marketingCampaignCompany.startDate)}</td>
                <td>{this.formatDate(marketingCampaignCompany.endDate)}</td>
                <td>{marketingCampaignCompany.active ? "Active" : "Inactive"}</td>
                {this.state.showComplete && <td>{marketingCampaignCompany.isComplete ? "Complete" : ""}</td>}
            </tr>
        )
    }

    editRow = (campaignCompany) => {
        return (<>
            <tr className="editRow adminRow text-left">
                <td>{this.state.editMarketingCampaignCompany.name}
                    {this.state.editMarketingCampaignCompany.description && <div><label>{this.state.editMarketingCampaignCompany.description}</label></div>}
                </td>
                <td>{this.state.editMarketingCampaignCompany.typeLabel}</td>
                <td colSpan={5}>
                    <Row className="py-2 text-left align-items-bottom ">
                        <Col md={8} className="text-left">
                            <Form inline>
                                {/* <FormGroup className="mr-2">
                                    <Input
                                        placeholder="Name"
                                        name="name"
                                        value={this.state.editMarketingCampaign.name + ''}
                                        onChange={e => this.onChange(e, 'edit')} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        placeholder='Description'
                                        name="description"
                                        value={this.state.editMarketingCampaign.description + ''}
                                        onChange={e => this.onChange(e, 'edit')} />
                                </FormGroup> */}
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="startDate"
                                        value={this.state.editMarketingCampaignCompany.startDate != null ? this.state.editMarketingCampaignCompany.startDate.substring(0, 10) : ''}
                                        onChange={e => this.onChange(e, 'edit')}>
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="endDate"
                                        value={this.state.editMarketingCampaignCompany.endDate != null ? this.state.editMarketingCampaignCompany.endDate.substring(0, 10) : ''}
                                        onChange={e => this.onChange(e, 'edit')}>
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Label>
                                        <Input
                                            type="checkbox"
                                            name="active"
                                            checked={this.state.editMarketingCampaignCompany.active}
                                            onChange={e => this.onChange(e, 'edit')}>
                                        </Input>Active
                                    </Label>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Label>
                                        <Input
                                            type="checkbox"
                                            name="isComplete"
                                            checked={this.state.editMarketingCampaignCompany.isComplete}
                                            onChange={e => this.onChange(e, 'edit')}>
                                        </Input>Complete
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col md={4} className="text-right">
                            <Button className="mr-3" color="success" onClick={this.handleEdit} title="Edit Campaign">
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                            {/* <Button className="mr-4" color="primary" onClick={() => this.onToggleConfigureMarketingCampaign(campaignCompany.campaignCompanyID)} title="Configure Campaign">
                                <FontAwesomeIcon icon={faWrench} />
                            </Button> */}
                            <ConfirmButton className="mr-4" color="danger" onClick={() => this.onDelete(campaignCompany.campaignCompanyID)} edit="Delete Campaign">
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </ConfirmButton>
                            <Button className="mr-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </Col>
                    </Row>
                </td>
            </tr>
            {campaignCompany.components != null && <tr>
                <td colSpan={7}>
                    <Table className='text-left bg-light mb-5 mt-0 mx-0'>
                        <thead>
                            <tr>
                                <th width="30%">Log</th>
                                <th width="15%">Assignee</th>
                                <th width="15%">Due/Completed</th>
                                <th width="10%">Type</th>
                                <th width="25%">Action</th>
                                <th width="5%">Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {campaignCompany.components.map((component, componentIndex) => (
                                <tr
                                    key={componentIndex}
                                    className={component.isComplete ? 'pointer' : ''}
                                    onClick={() => {
                                        if (!component.isComplete) return;
                                        this.openActionsModal(component, this.getToDoRender(component, true), this.props.contacts, true)
                                    }
                                    }>
                                    <td className='py-2'>{component.campaignCompanyTitle}</td>
                                    <td className='py-2'>
                                        {(componentIndex === campaignCompany.components.length - 1 && this.props.checkPermission('Reassign Workflow Task')) ?
                                            <Input
                                                type="select"
                                                name="componentAuth0"
                                                onChange={(e) => this.changeAssignee(component.componentCompanyID, component, e.target.value)}
                                                value={component.auth0}
                                            >
                                                {this.state.users.map(user => (
                                                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                                ))}
                                            </Input>
                                            :
                                            <>{component.fullName}</>
                                        }
                                    </td>
                                    <td className='py-2'><span className={!component.isComplete ? this.formatDueDate(component.endDate) : ''}>{component.endDate != null && `${this.formatDate(component.endDate)} ${this.formatTime(component.endDate)}`}</span></td>
                                    <td className='py-2'>{component.componentType}</td>
                                    <td className='py-2'>
                                        {this.getToDoRender(component)}
                                        {component.content != null && component.content !== '' && component.content !== 'null' && component.content.skipResponse != null ? (component.content.skipResponse ? 'Yes' : 'No') : ''}
                                        {componentIndex === campaignCompany.components.length - 1 && componentIndex > 0 &&
                                            <ConfirmButton
                                                size="sm"
                                                className="mr-4"
                                                color="danger"
                                                onClick={() => this.onDeleteComponent(component.componentCompanyID)}
                                                edit="Delete Component"
                                                disabled={this.state.editMarketingCampaignCompany.isComplete}
                                            >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </ConfirmButton>}
                                    </td>
                                    <td>{component.notes != null && component.notes !== '' ? 'Yes' : ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </td>
            </tr>}
        </>
        )
    }

    addRow = () => {
        return (
            <tr>
                <td colSpan={5}>
                    <Row className="py-2 mt-5 text-left align-items-bottom ">
                        <Col md={8}>
                            <Form inline>
                                <FormGroup className="mr-2">
                                    <Input
                                        name="campaignID"
                                        type="select"
                                        value={this.state.newMarketingCampaignCompany.campaignID}
                                        onChange={this.onChange}>
                                        <option value={0}>Campaign</option>
                                        {this.state.marketingCampaigns.map(marketingCampaign => (
                                            <option key={marketingCampaign.campaignID} value={marketingCampaign.campaignID}>{marketingCampaign.name}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="startDate"
                                        value={this.state.newMarketingCampaignCompany.startDate.substring(0, 10)}
                                        onChange={this.onChange} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="endDate"
                                        value={this.state.newMarketingCampaignCompany.endDate.substring(0, 10)}
                                        onChange={this.onChange} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Label>
                                        <Input
                                            type="checkbox"
                                            name="active"
                                            checked={this.state.newMarketingCampaignCompany.active}
                                            onChange={this.onChange} />
                                        Active
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col md={4} className="text-right">
                            <Button
                                disabled={this.state.newMarketingCampaignCompany.campaignID === 0}
                                color="primary"
                                onClick={this.handleAdd}
                            >Add Campaign</Button>
                        </Col>
                    </Row>
                </td>
            </tr>
        )
    }

    render() {
        return (
            <Container className="adminContainer" fluid>
                <Marketing2ActionsModal
                    clientToken={this.props.clientToken}
                    reload={this.props.getMarketingCampaignsCompanies}
                    markCompanyComponentComplete={this.markCompanyComponentComplete}
                    setOpenActionsModal={(fn) => {
                        this.openActionsModal = fn;
                    }}
                    setCloseActionsModal={(fn) => {
                        this.closeActionsModal = fn;
                    }}
                />
                <Row>
                    <Col className='text-right'>
                        <Label>
                            <Input
                                type="checkbox"
                                name="showComplete"
                                checked={this.state.showComplete}
                                onChange={(e) => this.setState({ showComplete: !this.state.showComplete })}
                            />Show Complete
                        </Label>
                    </Col>
                </Row>
                <Table width="100%">
                    <thead>
                        <tr className='text-left'>
                            <th width="25%">Workflow Name</th>
                            <th width="15%">Workflow Type</th>
                            <th width="15%">Start Date</th>
                            <th width="15%">End Date</th>
                            <th width={this.state.showComplete ? "15%" : "30%"}>Status</th>
                            {this.state.showComplete && <th width="15%">Complete</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.marketingCampaignsCompanies.filter(marketingCampaignCompany => this.state.showComplete || (!this.state.showComplete && !marketingCampaignCompany.isComplete)).map(marketingCampaignCompany => (
                            <Fragment key={marketingCampaignCompany.campaignCompanyID}>{this.state.editMarketingCampaignCompany.campaignCompanyID === marketingCampaignCompany.campaignCompanyID ? this.editRow(marketingCampaignCompany) : this.standardRow(marketingCampaignCompany)}</Fragment>
                        ))}
                        {this.addRow()}
                    </tbody>
                </Table>
            </Container>
        );

    }
}

export default Marketing2CampaignsDemographicsTable;
